var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CTextarea',{staticClass:"p-shopSurveyTextarea",attrs:{"name":"shop-survey-3","placeholder":_vm.$t('ここに記入してください。（任意）.アンケート回答:テキストエリア'),"auto-resize":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }